import type { ConversationThreadResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface PostscriptThreadViewProps {
  thread: ConversationThreadResponse;
}

export const PostscriptThreadView = memo(function PostscriptThreadView({
  thread,
}: PostscriptThreadViewProps) {
  return <ChatThreadView channel="postscript" thread={thread} />;
});
